import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsHeatmap from 'highcharts/modules/heatmap';
import { useAppContext } from '../../contexts/AppContext';
import { useMemo, useRef, useState } from 'react';
import { Backdrop, Box, CircularProgress } from '@mui/material';
import { asNamedSolutions, type ScreenSolution } from '../../types';
import { buildProductionLossesOptions } from '../../utils/chartOptions/productionLosses';

highchartsHeatmap(Highcharts);

type Props = {
  data: ScreenSolution[];
};

const CompareProductionLosses = ({ data }: Props) => {
  const { isDarkMode } = useAppContext();
  const chartComponent = useRef(null);
  const [isLoading] = useState(false);
  const chartOptions = useMemo(() => (data && data.length > 0 ? buildProductionLossesOptions(asNamedSolutions(data)) : null), [data]);

  return (
    <>
      <Box sx={{ /*display: 'flex',*/ justifyContent: 'center', pl: 1, pr: 1 }}>
        {isLoading ? (
          <Backdrop open={true} sx={{ width: '100%', height: '450px', position: 'relative' }}>
            <CircularProgress />
          </Backdrop>
        ) : (
          data &&
          chartOptions && (
            <>
              <HighchartsReact
                ref={chartComponent}
                containerProps={{ className: isDarkMode ? 'dark-chart' : '', style: { width: '100%' } }}
                highcharts={Highcharts}
                options={chartOptions}
              />
            </>
          )
        )}
      </Box>
    </>
  );
};

export default CompareProductionLosses;
